export const optionalMixin = {
  methods: {
    optional(obj, field, defaultValue = '') {
      return this.resolve(obj, field) ?? defaultValue;
    },
    resolve: (obj, field) => {
      return field.split('.').reduce((o, k) => o?.[k], obj)
    }
  }
}
